// Imports
import styled from "styled-components"
import { Link } from "react-router-dom"
import { Variables, Mixins } from "fajny-react"

const Container = styled(Link)`
    ${Mixins.Flexbox({
        $align: "center",
        $justify: "flex-start",
        $direction: "column",
        $gap: "xs",
    })};
    color: ${Variables.Colors.Black};
    text-decoration: none;
    font-weight: ${Variables.FontWeights.Regular};
    border: 1px solid ${Variables.Colors.Gray200};
    border-radius: ${Variables.Radiuses.M};
    padding: ${Variables.Spacers.S};
    text-align: center;
    transition: ${Variables.Transitions.Short};

    &:hover {
        transform: scale(1.02);
    }
`

export { Container }
